<template>
    <div class="checkout-cvs-result">
      <h2 class="title">7-11 門市選擇完成</h2>
  
      <!-- 提示訊息 & 倒數 -->
      <p class="hint-msg">
        您的門市資料已更新，將於
        <span class="countdown">{{ countdown }}</span>
        秒後自動返回結帳頁面
      </p>
  
      <!-- 門市資訊區塊 -->
      <div class="store-info">
        <p>門市代號：<span class="store-highlight">{{ storeID }}</span></p>
        <p>門市名稱：<span class="store-highlight">{{ storeName }}</span></p>
        <p>門市地址：<span class="store-highlight">{{ storeAddr }}</span></p>
      </div>
  
      <!-- {{userProfile}} -->
      <!-- 動作按鈕 -->
      <div class="actions">
        <button class="btn-back" @click="goBackCheckout">立即返回結帳頁</button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from 'vue'
  import { useStore } from 'vuex'          // <-- 透過 useStore 來拿到 store
  import { useRoute, useRouter } from 'vue-router'
  
  // 1) 定義響應式變數
  const storeID   = ref('')
  const storeName = ref('')
  const storeAddr = ref('')
  const countdown = ref(3) // 倒數秒數，可自行調整
  
  // 2) 取得 route、router、store
  const route = useRoute()
  const router = useRouter()
  const store  = useStore()
  
  // 3) 透過 computed() 讀取 state 裡的 userProfile
  const userProfile = computed(() => store.state.userProfile)
  
  // 4) 包裝一個 setUserProfile() method，對應到 mutation
  function setUserProfile(newProfile) {
    store.commit('setUserProfile', newProfile)
  }
  
  // 5) 定義需要的函式
  function goBackCheckout() {
    router.replace('/checkout')
  }
  
  function startCountdown() {
    let timer = setInterval(() => {
      countdown.value--
      if (countdown.value <= 0) {
        clearInterval(timer)
        goBackCheckout()
      }
    }, 1000)
  }
  
  // 6) 在 onMounted 做原先的邏輯
  onMounted(() => {
    // a) 從 URL query 取參數
    const q = route.query
    storeID.value   = q.storeID   || ''
    storeName.value = q.storeName || ''
    storeAddr.value = q.storeAddr || ''
  
    // // b) 將門市資訊寫到 localStorage
    // const checkoutDataStr = localStorage.getItem('checkoutForm')
    // if (checkoutDataStr) {
    //   const checkoutDataObj = JSON.parse(checkoutDataStr)
    //   if (!checkoutDataObj.cvsStore) {
    //     checkoutDataObj.cvsStore = {}
    //   }
    //   checkoutDataObj.cvsStore.store_id   = storeID.value
    //   checkoutDataObj.cvsStore.store_name = storeName.value
    //   checkoutDataObj.cvsStore.store_addr = storeAddr.value
    //   localStorage.setItem('checkoutForm', JSON.stringify(checkoutDataObj))
    // }

    // c) 如果要「直接在這裡」把 userProfile.addresses 更新成預設地址
    if (userProfile.value) {
          // 1) 確保 config 存在
        if (!userProfile.value.config) {
            userProfile.value.config = {}
        }
        // 2) 設定預設運送方式 (7-11 = 1)
        userProfile.value.config.default_shipping = 1
      // 假設這裡的邏輯是：先把舊的 7-11 门市全部改 is_default=0，然後新增／或覆蓋。
      const updatedAddresses = [...(userProfile.value.addresses || [])].map(addr => {
        if (addr.shipping_type === 'seven') {
          return { ...addr, is_default: 0 }
        }
        return addr
      })
  
      // 新增一筆新的
      const newSevenAddr = {
        user_id: userProfile.value.user_id,
        shipping_type: 'seven',
        store_id: storeID.value,
        store_name: storeName.value,
        store_addr: storeAddr.value,
        city: '',
        district: '',
        zip: '',
        street: '',
        is_default: 1,
      }
      updatedAddresses.push(newSevenAddr)
  
      // 最後透過 setUserProfile() 寫回 store
      setUserProfile({
        ...userProfile.value,
        addresses: updatedAddresses
      })
    }
  
    // d) 開始倒數 3 秒後導回 /checkout
    startCountdown()
  })
  </script>
  
  
  <style scoped>
  .checkout-cvs-result {
    max-width: 600px;
    margin: 0 auto;
    padding: 40px 20px;
    text-align: center;
    background-color: #fafafa;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  }
  .title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }
  .hint-msg {
    margin-bottom: 20px;
    font-size: 1rem;
    color: #555;
  }
  .countdown {
    font-weight: bold;
    color: #e67e22;
  }
  .store-info {
    margin: 20px 0;
    line-height: 1.6;
  }
  .store-highlight {
    color: #2c3e50;
    font-weight: 600;
  }
  .actions {
    margin-top: 20px;
  }
  .btn-back {
    padding: 10px 20px;
    font-size: 1rem;
    background-color: #3498db;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .btn-back:hover {
    background-color: #2980b9;
  }
  </style>
  